import { AddMultiLineTextEdit } from "../utils/AddMultiLineTextEdit";
import { AddStaticText } from "../utils/AddStaticText";
import { AddStdTextEdit } from "../utils/AddStdTextEdit";
import { appstr } from "../utils/appstr";
import { CenterIt } from "../utils/CenterIt.js";
import {
  enumKeyboardTargetEnterAction,
  enumPanelBorderStyle,
  enumShortCutModKeys,
  kAdminUser,
  kAlertButtonHeight,
  kAlertButtonSpacing,
  kAlertButtonWidth,
  kCancelDialog,
  kEnterOKShortCut,
  kFramelessHeaderHeight,
  kPickerBkgrnd,
  kStdTEHeight,
  kTabKey
} from "../constants";
import { QFramelessPanel } from "./QFramelessPanel";
import { QFramelessPanelDragger } from "./QFramelessPanelDragger";
import { QGetReportHistoryRFC } from "./QGetReportHistoryRFC";
import { QPanel } from "./QPanel";
import { QRadioButton } from "./QRadioButton";
import { QRadioButtonGroup } from "./QRadioButtonGroup";
import { QReportIssueRFC } from "./QReportIssueRFC";
import { QStdButton } from "./QStdButton";
import { ValidateEmailAddr } from "../utils/ValidateEmailAddr";
import { Globals } from "./Globals";
import { AddStdButton } from "../utils/AddStdButton.js";

export class QReportIssuePanel extends QPanel {
  constructor() {
    super();
    this.fWSMgr = null;
    this.fEditElements = null;
    this.fStatusRadio = null;
    this.fMessage = null;
    this.fApproved = true;
    this.fLogState = false;
    this.fLogButton = null;
  }

  InitIssuePanel(backGroundPanel, wsMgr) {
    var pW = 600; //220;
    var pH = 400;

    this.fWSMgr = wsMgr;
    this.SizePanel(pW, pH);

    var availableWidth = backGroundPanel.fWidth;
    var availableHeight = backGroundPanel.fHeight;

    var portX = backGroundPanel.fHorzOffset + CenterIt(availableWidth, pW);
    var portY = backGroundPanel.fVertOffset + CenterIt(availableHeight, pH);
    this.PositionPanel(portX, portY);

    this.SetModalOn(true);
    this.SetOutsideClickDismissOn(false);

    this.SetFillColor(kPickerBkgrnd);
    this.SetShadowOn(true);
    this.SetBorderThickness(1);
    this.SetBorderStyle(enumPanelBorderStyle.singleBorder);

    this.AddControls();
    wsMgr.PushPanel(this);
    wsMgr.SetKeyboardTarget(this.fEditElements[0], this, enumKeyboardTargetEnterAction.selectAll);
  }

  AddControls() {
    var ut = Globals._accountInfo.GetUserRole();
    var isAdmin = ut === kAdminUser;
    var pWidth = this.GetWidth();
    var pHeight = this.GetHeight();

    this.fHeader = this.addFramelessHeader("Report errors and omissions");
    /*
	var exitbutton = AddFramelessExitButton(this);
	exitbutton.SetCmdCode("CnclReport");
	exitbutton.SetPositionX(this.fWidth-exitbutton.fWidth-2);
	//Why doesn't this work???
	*/
    this.fPanelDragger = new QFramelessPanelDragger();
    this.fPanelDragger.InitPanelDragger(this);
    this.fPanelDragger.PositionElement(0, 0);
    this.fPanelDragger.SizeElement(this.fWidth, kFramelessHeaderHeight);
    this.PushElement(this.fPanelDragger);

    this.fEditElements = [];

    var xPos = 20;
    var xPos2 = 100;
    var vSpacer = 12;

    var teWidth = pWidth - xPos2 - xPos;
    var yPos = this.fHeader.GetHeight();
    yPos += kStdTEHeight + vSpacer;
    AddStaticText(this, xPos, yPos, "Your name:", false, "#000000");
    var te = AddStdTextEdit(this, xPos2, yPos + 2, teWidth, kStdTEHeight, "", 50, 0, true);
    this.fEditElements.push(te);

    yPos += kStdTEHeight + vSpacer;
    AddStaticText(this, xPos, yPos, "Your email:", false, "#000000");
    te = AddStdTextEdit(this, xPos2, yPos + 2, teWidth, kStdTEHeight, "", 50, 1, true);
    this.fEditElements.push(te);

    var nLines = 2;
    var teHeight = 12 * nLines + 2 * nLines;
    yPos += kStdTEHeight + vSpacer;
    AddStaticText(this, xPos, yPos, "Notify:", false, "#000000");
    te = AddMultiLineTextEdit(this, xPos2, yPos + 2, teWidth, teHeight, "", 200, 2, true, 2);
    this.fEditElements.push(te);

    yPos += teHeight + vSpacer;
    nLines = 10;
    teHeight = teHeight = 12 * nLines + 2 * nLines;
    AddStaticText(this, xPos, yPos, "Message:", false, "#000000");
    te = AddMultiLineTextEdit(this, xPos2, yPos + 2, teWidth, teHeight, "", 500, 3, true, nLines);
    this.fEditElements.push(te);

    yPos += teHeight + vSpacer;
    var report_status = [
      ["Approve", "ReportApprove"],
      ["Reject", "ReportReject"]
    ];
    var rG = new QRadioButtonGroup();
    rG.InitRadioButtonGroup(report_status, xPos2, yPos, this, 0, false, false);
    this.fStatusRadio = rG;

    var adder = kAlertButtonWidth + kAlertButtonSpacing;
    var yPos = pHeight - kAlertButtonHeight - kAlertButtonSpacing;
    this.AddButton(pWidth - adder, yPos, "Submit", "OKReport", kEnterOKShortCut);
    this.AddButton(pWidth - adder * 2, yPos, appstr("Cancel"), "CnclReport", kCancelDialog);
    this.fLogButton = AddStdButton(
      this,
      pWidth - adder * 3,
      yPos,
      65,
      20,
      appstr("ActivityLog"),
      "DownloadReport"
    );
    this.fMessage = AddStaticText(this, xPos, yPos, "", false, "#FF0000");
    this.fLogButton.SetEnabled(isAdmin);
  }

  AddButton(x, y, label, cmdCode, shortCut) {
    var aButton = new QStdButton();
    aButton.PositionElement(x, y);
    aButton.SizeElement(kAlertButtonWidth, kAlertButtonHeight);
    aButton.SetLabel(label);
    aButton.SetCmdCode(cmdCode);
    if (shortCut != null) aButton.SetCmdShortCut(shortCut, enumShortCutModKeys.none, "");
    this.PushElement(aButton);
  }

  SetMessage(msg) {
    this.fMessage.SetLabel(msg);
    this.fMessage.AutoSize();
  }

  Validate() {
    var nameEdit = this.fEditElements[0];
    var content = nameEdit.GetRealContent();
    var valid = content.length > 0;
    if (!valid) {
      this.SetMessage("Name cannot be blank.");
      return valid;
    }

    var emailEdit = this.fEditElements[1];
    content = emailEdit.GetRealContent();
    valid = ValidateEmailAddr(content);
    if (!valid) {
      this.SetMessage("Email address is invalid.");
      return valid;
    }

    var toEdit = this.fEditElements[2];
    content = toEdit.GetRealContent();
    var n = 0;
    var parts = null;

    if (content.length > 0) {
      parts = content.split(",");
      n = parts.length;
    }

    for (var i = 0; i < n; i++) {
      var p = parts[i].trim();
      valid = ValidateEmailAddr(p);
      if (!valid) {
        this.SetMessage("One or more notify email addresses are invalid.");
        return valid;
      }
    }

    var msgEdit = this.fEditElements[3];
    content = msgEdit.GetRealContent();
    var valid = content.length > 0;
    if (!valid) {
      this.SetMessage("Message cannot be blank.");
      return valid;
    }

    return valid;
  }

  SendMessage() {
    var nameEdit = this.fEditElements[0];
    var username = nameEdit.GetRealContent();
    var emailEdit = this.fEditElements[1];
    var useremail = emailEdit.GetRealContent();
    var toEdit = this.fEditElements[2];
    var toEmail = toEdit.GetRealContent();
    var msgEdit = this.fEditElements[3];
    var msg = msgEdit.GetRealContent();
    var status = this.fApproved ? "Approved" : "Rejected";

    var rfc = new QReportIssueRFC();
    rfc.InitReportIssue(this);

    var w = this.fWSMgr;
    var curUser = w.GetUserName();
    var curOrg = w.GetAccountName();

    rfc.SetParams(curOrg, curUser, username, useremail, toEmail, msg, status);
    Globals._rfcMgr.QueueRFC(rfc);
  }

  GetReportHistory() {
    var rfc = new QGetReportHistoryRFC();
    rfc.InitReportIssue(this);

    var w = this.fWSMgr;
    var curUser = w.GetUserName();
    var curOrg = w.GetAccountName();

    rfc.SetParams(curOrg, curUser);
    Globals._rfcMgr.QueueRFC(rfc);
  }

  ExecuteCommand(aCmd) {
    var cmdCode = aCmd.GetCmdCode();
    var wsMgr = aCmd.GetWSMgr();
    var panelHandled = true;
    var closePanel = false;

    switch (cmdCode) {
      case "ReportApprove":
        this.fStatusRadio.SelectRadioButtonByIndex(0);
        this.fApproved = true;
        break;
      case "ReportReject":
        this.fStatusRadio.SelectRadioButtonByIndex(1);
        this.fApproved = false;
        break;
      case "OKReport":
        var isOK = this.Validate();
        if (isOK) this.SendMessage();
        closePanel = isOK;
        panelHandled = true;
        break;
      case "CnclReport":
        closePanel = true;
        panelHandled = true;
        break;
      case "DownloadReport":
        this.GetReportHistory();
        break;
      default:
        panelHandled = false;
        break;
    }

    if (closePanel) wsMgr.RemovePanel(this);

    return panelHandled;
  }

  TabToNextElement(shiftOff, targetElement) {
    var curTargetElement = targetElement;

    if (curTargetElement) {
      var adder = -1;
      if (shiftOff) adder = 1;

      var theList = this.fEditElements;
      var n = theList.length;
      var nextTabID = curTargetElement.GetTabID() + adder;
      if (nextTabID >= n) nextTabID = 0;
      if (nextTabID < 0) nextTabID = n - 1;

      var nextElement = theList[nextTabID];

      if (nextElement != curTargetElement)
        this.fWSMgr.SetKeyboardTarget(nextElement, this, enumKeyboardTargetEnterAction.selectAll);
    }
  }

  PanelHandleKeyboard(keyInfo, targetElement, wsMgr) {
    var handled = true;
    var keyCode = keyInfo.keyCode;

    switch (keyCode) {
      case kTabKey:
        this.TabToNextElement(!keyInfo.shiftKey, targetElement, wsMgr);
        break;
      default:
        handled = false;
        break;
    }

    return handled;
  }

  IssueReported(success, result) {}
}
